import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import { ProductOrder } from 'feature/productOrder/ProductOrder'
import { useGetMainPageDataQuery } from 'feature/user/redux/user.api'
import { MainLayout } from 'layouts'
import { Navigate } from 'react-router'
import { RequireAuth } from 'router/RequireAuth'
import { useAppSelector } from 'store/hooks'
import { LoaderInCentalPosition } from 'widget/LoaderInCentalPosition/LoaderInCentalPosition'

function CompanyProductOrderContent() {
  const clientType = useAppSelector(state => state.auth.authInfo.clientType)

  const { isLoading } = useGetMainPageDataQuery(undefined, {
    skip: !!clientType,
  })

  if (!clientType && isLoading) {
    return (
      <MainLayout>
        <LoaderInCentalPosition />
      </MainLayout>
    )
  }

  if (clientType === 'personal') return <Navigate to='/productorder' replace />

  return (
    <MainLayout>
      <ProductOrder
        orderType={orderFormSpace.FormType.newCompany}
        forceUserType='company'
      />
    </MainLayout>
  )
}

export function CompanyProductOrderPage() {
  return (
    <RequireAuth>
      <CompanyProductOrderContent />
    </RequireAuth>
  )
}
